import { imgLogo2 } from "@/shared/assets/img";

export default function AccountSidebarHeader() {
  return (
    <div className="flex items-center justify-between  pb-7.5 mb-7.5 w-full relative ">
      <img src={imgLogo2} alt="Logo" className="h-7" />
      <div className="bottom-0 inset-x-0 h-px bg-gradient-to-r from-inverted to-inverted/50 opacity-6 dark:opacity-60 dark:mix-blend-overlay absolute" />
    </div>
  );
}
